import { MessageMarkdownSerializer } from '@chatwoot/prosemirror-schema';
import { serializeMention } from './editorMentionHelper';

// Keep the Community serializer's block/mark handlers. Its default text handler
// deliberately leaves Markdown syntax unescaped for messaging integrations.
// Rich editors importing literal history need the library's escaping instead.
const literalSerializer = new MessageMarkdownSerializer.constructor(
  {
    ...MessageMarkdownSerializer.nodes,
    mention: serializeMention,
    text: (state, node) => state.text(state.esc(node.text, true), false),
    hard_break: state => state.write('\\\n'),
  },
  MessageMarkdownSerializer.marks,
  { escapeExtraCharacters: /[<>|]/g }
);

const mentionSerializer = new MessageMarkdownSerializer.constructor(
  { ...MessageMarkdownSerializer.nodes, mention: serializeMention },
  MessageMarkdownSerializer.marks
);

export const serializeEditorContent = (doc, escapePlainText) =>
  (escapePlainText ? literalSerializer : mentionSerializer).serialize(doc);

export const literalEditorDocument = (content, schema) =>
  schema.node('doc', null, [
    schema.node(
      'paragraph',
      null,
      content
        .split('\n')
        .flatMap((line, index) => [
          ...(index ? [schema.node('hard_break')] : []),
          ...(line ? [schema.text(line)] : []),
        ])
    ),
  ]);
